import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const EncodedReportView = () => {
  const { encoded } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // Decode the Base64 string
      const decoded = atob(encoded);
      
      // Navigate to the actual report
      navigate(`/${decoded}`, { replace: true });
    } catch (error) {
      console.error('Invalid encoded URL:', error);
      // Redirect to home if decode fails
      navigate('/', { replace: true });
    }
  }, [encoded, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ 
          fontSize: '48px', 
          marginBottom: '20px',
          animation: 'spin 1s linear infinite'
        }}>
          🔓
        </div>
        <h2>Decoding Report...</h2>
        <p style={{ color: '#666', marginTop: '10px' }}>
          Please wait
        </p>
      </div>
      
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default EncodedReportView;
